import Handler from "../Handler";

class MaintenanceHandler extends Handler {
  execute() {
    this.service.processMaintenancePopup();
  }
}

export default MaintenanceHandler;
